import React, { FC } from 'react';
import { IItem } from 'src/graphql/types';

const DeliveryPriorityData: FC<{ item: IItem }> = ({ item }) => {
  if (item.deliveries.length === 0) {
    return <span>—</span>;
  }
  return <div>{item.deliveries[0].deliveryPriority}</div>;
};

export { DeliveryPriorityData };
